export class UpdateCostOffsetCodeError extends Error {
  constructor(
    message: string = 'Failed to update cost offset code',
    options?: { cause?: unknown }
  ) {
    super(message, options);
    this.name = 'UpdateCostOffsetCodeError';
  }
}
